import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../components/Button';

const VerificationOfCoverageDental = () => {
  return (
    <Container className={'px-0'}>
      <Row className={'align-items-center mt-10 mt-lg-13'}>
        <Col className={'col-12 col-lg-6'}>
          <span className={'text-sm-16-lg-24 fw-normal lx-xxs'}>
            Dental Coverage
          </span>
        </Col>

        <Col className={'col-12 col-lg-6 text-end'}>
          <a
            className={'text-decoration-none'}
            href={`${
              process.env.PUBLIC_URL
            }/${'VerificationCoverageDental.pdf'}`}
            target={'_blank'}
            rel="noreferrer"
          >
            <Button leftIcon={light('file-download')}>Download/Print</Button>
          </a>
        </Col>

        <Container className={'px-0 overflow-auto'}>
          <Col
            style={{ minWidth: 643 }}
            className={'col-12 text-center py-10 pb-lg-13'}
          >
            <img
              className={'w-100 h-auto'}
              src={`${
                process.env.PUBLIC_URL
              }/${'dental-verification-of-coverage.png'}`}
              alt=""
            />
          </Col>
        </Container>
      </Row>
    </Container>
  );
};

export default VerificationOfCoverageDental;
